<template lang="pug">
.template-item-component
  .section-and-group(v-if="isSection(value) || isGroup(value)" :class="_margin")
    //- type: section
    .template-section-item.d-flex.flex-column(v-if="isSection(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text") {{ value.text }}
      .section-text.warning-message(v-if="value.strongText") {{ value.strongText }}
      .mb-2
      .section-items
        .section-item(v-for="(property, index) in value.properties" :key="property.id")
          WaiterTemplateSelectItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: group
    .template-group-item.d-flex.flex-column.mb-3(v-if="isGroup(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text") {{ value.text }}
      .section-text.warning-message(v-if="value.strongText") {{ value.strongText }}
      .mb-2
      .group-items(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .group-item.pt-2.pb-2.mb-2
          .group-child-item(v-for="(childProperty, childIndex) in property" :key="value.id + '-' + index + '-' + childIndex")
            WaiterTemplateSelectItem(v-model="value.properties[index][childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
          .d-flex.flex-row.justify-content-end.mr-3.mb-1
            button.btn.group-delete-btn(@click="onDeleteGroupItem(value, index)") 削除

      .buttons.d-flex.flex-row.justify-content-end
        button.btn.group-add-btn(@click="onAddGroupItem(value)"
          :class="{ 'disable': disableAddGroupItemButton(value) }" :disabled="disableAddGroupItemButton(value)") {{ value.displayAddButtonLabel }}

  .template-items(v-else :class="{ 'facility-only': value.displayToUser == false }").mr-3.mb-3.ml-3
    //- type: text
    .template-item.d-flex.flex-column(v-if="isText(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center(v-if="value.prefix || value.suffix")
        .text-prefix.mr-2(v-if="value.prefix") {{ value.prefix }}
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :style="getTextStyle(value)" disabled)
        .text-suffix.ml-2 {{ value.suffix }}
      div(v-else)
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :style="getTextStyle(value)" disabled)

    //- type: radio
    .template-item.d-flex.flex-column(v-if="isRadio(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      template(v-if="value.align == 'vertical'")
        template(v-for="(option, index) in value.options")
          .radio-item
            b-form-radio(v-model="value.answer" :name="value.id" :value="option.value" disabled) {{ option.text }}
      template(v-else)
        b-form-radio-group(:id="value.id" v-model="value.answer" :name="value.id" :options="value.options" disabled)

    //- type: radioGroup
    .template-item-radio-group.d-flex.flex-column(v-if="isRadioGroup(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}
      
      .radio-items.mb-2(v-if="value.properties" v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .radio-item
          b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value" disabled) {{ property.option.text }}
        .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length")
          .group-child-item(v-for="(childProperty, childIndex) in property.properties" :key="value.id + '-' + index + '-' + childIndex")
            WaiterTemplateSelectItem(v-model="value.properties[index].properties[childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: select
    .template-item.d-flex.flex-column(v-if="isSelect(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      b-form-select.d-flex.flex-column(:id="value.id" v-model="value.answer" :name="value.id" :options="value.options" :multiple="value.multiple" disabled)

    //- type: checkbox
    .template-item.d-flex.flex-column(v-if="isCheckbox(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false" @input="onItem(value)" disabled) {{ value.question }}

    //- type: siwtch checkbox
    .template-item-switch-checkbox.d-flex.flex-column(v-if="isSwitchCheckbox(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false" disabled) {{ value.question }}

      .checkbox-items.mt-2.mb-2
        .checkbox-property.pt-2.mt-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
          WaiterTemplateSelectItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: multipleCheckbox
    .template-item.d-flex.flex-column(v-if="isMultipleCheckbox(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .checkbox.mb-2(v-for="(question, index) in value.questions")
        b-form-checkbox(:id="value.id + '-' + index" v-model="value.answer[index]" :name="value.id + '-' + index"
          :value="true" :unchecked-value="false" @input="onItem(value)" disabled) {{ value.questions[index] }}

    //- type: textarea
    .template-item.d-flex.flex-column(v-if="isTextarea(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      b-form-textarea(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :rows="value.rows"
        :no-resize="value.noResize" :minlength="value.minlength" :maxlength="value.maxlength" disabled)

    //- type: address
    .template-item-address.d-flex.flex-column(v-if="isAddress(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row
        b-form-input.postal-code.mb-1.mr-2(:id="value.id + '-postal-code'" v-model="value.answer.postalCode" :name="value.id + '-postal-code'"
          placeholder="郵便番号" maxlength="8" disabled)
      b-form-input(:id="value.id + '-address'" v-model="value.answer.address" :name="value.id + '-address'" placeholder="住所" maxlength="100" disabled)

    //- type: birthday
    .template-item-birthday.d-flex.flex-column(v-if="isBirthday(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)" disabled)
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()" disabled)
        span.ml-2.mr-2 月
        b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()" disabled)
        span.ml-2.mr-2 日
        span(v-if="value.answer && value.answer.month &&value.answer.date ") （{{ createAge(value) }}歳）

    //- type: yearMonthDate
    .template-item-year-month-date(v-if="isYearMonthDate(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)" disabled)
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()" disabled)
        span.ml-2.mr-2 月
        b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()" disabled)
        span.ml-2.mr-2 日
        span.ml-2(v-if="value.suffix") {{ value.suffix }}

    //- type: yearMonth
    .template-item-year-month-date(v-if="isYearMonth(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)" disabled)
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()" disabled)
        span.ml-2.mr-2 月
        span.ml-2(v-if="value.suffix") {{ value.suffix }}

    //- type: roomType
    .template-item-room-type(v-if="isRoomType(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .facility-recruitment(v-for="(checkbox, index) in value.answer")
        span.facility-name ・{{ getFacilityName(value.answer[index]) }}
        .checkboxs.ml-3
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'multiBed')" :id="value.id + '-' + checkbox.facilityId + '-multiBed'"
            v-model="value.answer[index].recruitmentRoom.multiBed" :value="true" :unchecked-value="false" disabled) 従来型多床室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'conventinalSingle')" :id="value.id + '-' + checkbox.facilityId + '-conventinalSingle'"
            v-model="value.answer[index].recruitmentRoom.conventinalSingle" :value="true" :unchecked-value="false" disabled) 従来型個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'unitTypeSingle')" :id="value.id + '-' + checkbox.facilityId + '-unitTypeSingle'"
            v-model="value.answer[index].recruitmentRoom.unitTypeSingle" :value="true" :unchecked-value="false" disabled) ユニット型個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'single')" :id="value.id + '-' + checkbox.facilityId + '-single'"
            v-model="value.answer[index].recruitmentRoom.single" :value="true" :unchecked-value="false" disabled) 個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'double')" :id="value.id + '-' + checkbox.facilityId + '-double'"
            v-model="value.answer[index].recruitmentRoom.double" :value="true" :unchecked-value="false" disabled) ２人部屋（夫婦部屋）
        .checkboxs.ml-3(v-if="value.answer[index].customRecruitmentRoom && 0 < value.answer[index].customRecruitmentRoom.length")
          b-form-checkbox(v-if="showCustomRecruitmentRoom(value.answer[index], room)"
            v-for="(room, roomIndex) in value.answer[index].customRecruitmentRoom"
            :id="value.id + '-' + checkbox.facilityId + '-' + room.id"
            v-model="value.answer[index].customRecruitmentRoom[roomIndex].use" :value="true" :unchecked-value="false" disabled) {{ room.name }}

    //- type: file is hide

    //- type: tel
    .template-item-tel.d-flex.flex-column(v-if="isTel(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center
        b-form-input.tel-input(:id="value.id + '-first'" v-model="value.answer.first" :name="value.id + '-first'" :minlength="3" :maxlength="4" disabled)
        span.ml-2.mr-2 －
        b-form-input.tel-input(:id="value.id + '-second'" v-model="value.answer.second" :name="value.id + '-second'" :minlength="3" :maxlength="4" disabled)
        span.ml-2.mr-2 －
        b-form-input.tel-input(:id="value.id + '-third'" v-model="value.answer.third" :name="value.id + '-third'" :minlength="3" :maxlength="4" disabled)

    //- type: name
    .template-item-name.d-flex.flex-column(v-if="isName(value)" :class="{ 'checked': value.checked }" @click.stop="onItem(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text") {{ value.text }}
        .text.warning-message(v-if="value.strongText") {{ value.strongText }}

      .d-flex.flex-row.align-items-center.mb-1
        span.template-item-name-sub-label.mr-2 姓
        b-form-input.name-input.mr-4(:id="value.id + '-second'" v-model="value.answer.secondName" :name="value.id + '-second'"
          :placeholder="'姓'" :maxlength="15" disabled)
        span.template-item-name-sub-label.mr-2 名
        b-form-input.name-input(:id="value.id + '-first'" v-model="value.answer.firstName" :name="value.id + '-first'"
          :placeholder="'名'" :maxlength="15" disabled)
      .d-flex.flex-row.align-items-center
        span.template-item-name-sub-label.mr-2 せい
        b-form-input.name-input.mr-4(:id="value.id + '-second-kana'" v-model="value.answer.secondKanaName" :name="value.id + '-second-kana'"
          :placeholder="'せい'" :maxlength="15" disabled)
        span.template-item-name-sub-label.mr-2 めい
        b-form-input.name-input(:id="value.id + '-first-kana'" v-model="value.answer.firstKanaName" :name="value.id + '-first-kana'"
          :placeholder="'めい'" :maxlength="15" disabled)
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import {
  TemplateItem,
  TemplateType,
  TemplateItemBirthday,
  TemplateItemYearMonthDate,
  TemplateItemInput,
  TemplateItemGroup,
  TemplateItemText,
  RoomType
} from "@/commons/services/AdmissionApplicationTemplates";
import { CustomRecruitmentRoom, FacilityGetModel, RecruitmentRoom } from "@/commons/services/Facilities";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import ChildTemplateItem from "@/pc/containers/waiters/WaiterTemplateSelectItem.vue";

/**
 * ### 入居申込テンプレート項目選択コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    ChildTemplateItem
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "WaiterTemplateSelectItem"
})
export default class WaiterTemplateSelectItem extends Vue {
  /** テンプレート情報 */
  @Prop({ required: true })
  value!: TemplateItem;

  /** 閲覧可能施設 */
  @Prop({ required: true })
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  /** 子要素かどうか */
  @Prop({ required: true })
  isChaild!: boolean;

  /** type:address のエラーメッセージ */
  addressErrorMessage: string = "";

  /** type:file のPDFプレビューモーダル表示可否 */
  showPdfModal: boolean = false;
  /** type:file のPDFプレビューモーダルで表示する対象のURL */
  pdfModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showImageModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  imageModalUrl: string = "";
  /** type:file のエラーメッセージ */
  fileErrorMesage: string = "";

  get _margin(): string[] {
    if (this.isChaild == true) {
      return ["mr-3", "mb-3", "ml-3"];
    } else {
      return [""];
    }
  }

  public isSection(item: TemplateItem): boolean {
    if (item.type != TemplateType.SECTION) {
      return false;
    }
    return true;
  }

  public isGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.GROUP) {
      return false;
    }
    return true;
  }

  public onDeleteGroupItem(item: TemplateItemGroup, index: number): void {
    item.properties.splice(index, 1);

    // idの採番し直し
    for (let i = 0; i < item.properties.length; i++) {
      for (let j = 0; j < item.properties[i].length; j++) {
        const id: string = item.template[i].id;
        item.properties[i][j].id = `${id}${i}`;
      }
    }

    return;
  }

  public disableAddGroupItemButton(item: TemplateItemGroup): boolean {
    if (item.displayAddButton && !item.max) {
      console.error("template format error. type:group displayAddButton=true but max=undefined");
      return true;
    }
    if (item.max && item.properties.length < item.max) {
      return false;
    }

    return true;
  }

  public onAddGroupItem(item: TemplateItemGroup): void {
    let templateClone: Array<SelectTemplateItem> = JSON.parse(JSON.stringify(item.template));

    const suffix: number = item.properties.length;
    for (const cloneItem of templateClone) {
      cloneItem.id = `${cloneItem.id}${suffix}`;
      cloneItem.checked = false;
    }
    item.properties.push(templateClone);

    return;
  }

  public isText(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public getTextStyle(item: TemplateItemText): string {
    if (!item.width) {
      return "";
    }
    return `width:${item.width}px;`;
  }

  public isRadio(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO) {
      return false;
    }
    return true;
  }

  public isRadioGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO_GROUP) {
      return false;
    }
    return true;
  }

  public isSelect(item: TemplateItem): boolean {
    if (item.type != TemplateType.SELECT) {
      return false;
    }
    return true;
  }

  public isCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.CHECKBOX) {
      return false;
    }
    return true;
  }

  public isSwitchCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.SWITCH_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isMultipleCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.MULTIPLE_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isTextarea(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXTAREA) {
      return false;
    }
    return true;
  }

  public isAddress(item: TemplateItem): boolean {
    if (item.type != TemplateType.ADDRESS) {
      return false;
    }
    return true;
  }

  public isBirthday(item: TemplateItem): boolean {
    if (item.type != TemplateType.BIRTHDAY) {
      return false;
    }
    return true;
  }

  public getYearOptions(item: TemplateItemBirthday | TemplateItemYearMonthDate): Array<{ text: string; value: string }> {
    let options: Array<{ text: string; value: string }> = [];

    const currentYear: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyy");
    const startPosition: number = currentYear - item.startYearRange;
    const count: number = item.startYearRange + item.endYearRange;

    for (let i = 0; i <= count; i++) {
      const year: number = startPosition + i;
      const date = new Date(year, 11, 31, 0, 0);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;

      options.push({
        text: `${year}（${jpYear}）`,
        value: `${year}`
      });
    }

    return options;
  }

  public getMonthOptions(): Array<{ text: string; value: string }> {
    let options: Array<{ text: string; value: string }> = [];

    for (let i = 1; i <= 12; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public getDateOptions(): Array<{ text: string; value: string }> {
    let options: Array<{ text: string; value: string }> = [];

    for (let i = 1; i <= 31; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public createAge(item: TemplateItemBirthday): number {
    const age: number = this.$dateUtil.convertBirthdayToAge(Number(item.answer.year), Number(item.answer.month), Number(item.answer.date));
    return age;
  }

  public isYearMonthDate(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH_DATE) {
      return false;
    }
    return true;
  }

  public isYearMonth(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH) {
      return false;
    }
    return true;
  }

  public isRoomType(item: TemplateItem): boolean {
    if (item.type != TemplateType.ROOM_TYPE) {
      return false;
    }
    return true;
  }

  public showRecruitmentRoom(roomType: RoomType, roomTypeName: string): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return false;
    }
    const recruitmentRoom: RecruitmentRoom = facility.recruitmentRoom;

    return recruitmentRoom[roomTypeName];
  }

  public showCustomRecruitmentRoom(roomType: RoomType, room: CustomRecruitmentRoom): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    // 施設にカスタム部屋種類が存在しない場合は表示不要
    if (!facility || !facility.customRecruitmentRoom || facility.customRecruitmentRoom.length <= 0) {
      return false;
    }

    // 施設のカスタム部屋種類の使用可否を表示可否として返す
    for (const customRoom of facility.customRecruitmentRoom) {
      if (customRoom.id == room.id) {
        return customRoom.use;
      }
    }

    return false;
  }

  public getFacilityName(roomType: RoomType): string {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return "";
    }

    return facility.name;
  }

  public isTel(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEL) {
      return false;
    }
    return true;
  }

  public isName(item: TemplateItem): boolean {
    if (item.type != TemplateType.NAME) {
      return false;
    }
    return true;
  }

  public isRequired(item: TemplateItemInput): boolean {
    if (item.validationRules == null) {
      return false;
    }

    for (const validationRule of item.validationRules) {
      if (validationRule == "required") {
        return true;
      }
    }
    return false;
  }

  /**
   * ### Itemのクリックイベント
   *
   * - 選択を反転させる
   * - 一度も選択されていない場合はundefinedなのでfalseとして扱う
   */
  public onItem(item: SelectTemplateItem): void {
    item.checked = !item.checked;
    return;
  }
}

export interface SelectTemplateItem extends TemplateItem {
  /** 選択しているか否か */
  checked: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.template-item-component {
  .section-label,
  .item-label {
    font-weight: bold;
  }

  .section-text,
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .template-group-item {
    .group-item {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }

    .group-delete-btn,
    .group-add-btn {
      font-size: 16px !important;
      height: 38px !important;
    }
  }

  .facility-only {
    background-color: rgba(245, 245, 245, 1);
  }
  .facility-only-label {
    color: rgba(138, 138, 138, 1);
    font-size: 10px;
    border: 1px solid rgba(138, 138, 138, 1);
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
    background-color: #fff;
  }

  .template-item,
  .template-item-radio-group,
  .template-item-switch-checkbox,
  .template-item-address,
  .template-item-birthday,
  .template-item-year-month-date,
  .template-item-year-month-date,
  .template-item-tel,
  .template-item-name,
  .template-item-room-type {
    padding: 6px;
    border: 2px dashed rgba(112, 112, 112, 1);
    border-radius: 4px;

    &.checked {
      border: 2px solid rgba(0, 140, 160, 1);
      background-color: rgba(0, 140, 160, 0.1);
    }

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 140, 160, 0.1) !important;
      transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
    }
  }

  .template-item-radio-group {
    .radio-properties {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      background: #fff;
    }
  }

  .template-item-switch-checkbox {
    .checkbox-items {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      background: #fff;
    }
  }

  .template-item-address {
    .postal-code {
      width: 160px;
    }
    .search-address-btn {
      font-size: 16px !important;
      width: 100px !important;
      height: 38px !important;
    }
  }

  .template-item-birthday,
  .template-item-year-month-date {
    .year {
      width: 180px;
    }
    .month {
      width: 70px;
    }
    .date {
      width: 70px;
    }
  }

  .template-item-room-type {
    .facility-name {
      font-weight: bold;
    }
  }

  .template-item-tel {
    .tel-input {
      width: 80px;
    }
  }

  .template-item-name {
    .template-item-name-sub-label {
      width: 2rem;
    }
    .name-input {
      width: 300px;
    }
  }

  // 子コンポーネントに強制的にスタイルを指定しないとdisabledのせいで表示が見にくい
  ::v-deep {
    .custom-control-label {
      color: $font-base-color !important;
    }
    ::placeholder {
      color: $font-base-color !important;
    }
  }
}
</style>
